module.exports = __webpack_public_path__ + "img/result_wine_i.ea030c3e.png";